import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './styles/SaveProjectDialog.module.css'; // Percorso aggiornato
import { X } from 'lucide-react';

interface SaveProjectDialogProps {
  onSave: (projectName: string) => void;
  onClose: () => void;
}

const SaveProjectDialog: React.FC<SaveProjectDialogProps> = ({ onSave, onClose }) => {
  const [projectName, setProjectName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  // Focus sull'input quando il dialog si apre
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleSaveClick = () => {
    // Semplice validazione per non permettere nomi vuoti
    if (projectName.trim()) {
      onSave(projectName.trim());
      onClose(); // Chiude dopo aver salvato
    } else {
      // Opzionale: mostrare un messaggio di errore o evidenziare l'input
      if (inputRef.current) {
        inputRef.current.focus(); // Rimette il focus sull'input
      }
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setProjectName(event.target.value);
  };

  // Gestisce il tasto Invio per salvare
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSaveClick();
    }
  };

  // Il dialog viene renderizzato nel body tramite Portal
  return ReactDOM.createPortal(
    <div className={styles.dialogOverlay} onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="save-dialog-title">
      <div className={styles.dialogContent} onClick={(e) => e.stopPropagation()} role="document">
        <button className={styles.closeButton} onClick={onClose} aria-label="Chiudi">
          <X size={18} />
        </button>
        <h2 id="save-dialog-title" className={styles.dialogTitle}>Salva Progetto</h2>
        <div className={styles.inputGroup}>
          <label htmlFor="projectNameInput" className={styles.inputLabel}>Nome del Progetto:</label>
          <input
            ref={inputRef}
            id="projectNameInput"
            type="text"
            value={projectName}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            className={styles.textInput}
            placeholder="Es: mio_progetto_geo"
          />
        </div>
        <div className={styles.buttonGroup}>
          <button onClick={onClose} className={`${styles.dialogButton} ${styles.cancelButton}`}>
            Annulla
          </button>
          <button
            onClick={handleSaveClick}
            className={`${styles.dialogButton} ${styles.saveButton}`}
            disabled={!projectName.trim()} // Disabilita se l'input è vuoto
          >
            Salva
          </button>
        </div>
      </div>
    </div>,
    document.body // Target del portal
  );
};

export default SaveProjectDialog;